import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  root: {
    padding: '2em 0',
    backgroundColor: theme.palette.grey[100],
    width: '100%'
  },
  title: {
    opacity: '.5'
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.text.secondary
  },
  cardContainer: {
    marginTop: theme.spacing(2)
  },
  loading: { height: '100vh' }
}))